import * as React from "react";
import { Location, Redirect } from "react-router-dom";
import { RouterState } from "react-router-redux";
import { connect } from "react-redux";

import { RootState, Dispatch } from "../../../store/types";
import http from "../../../helpers/http";
import { selectors as authSelectors, actions as authActions } from "../../Auth";
import Success from "./Success";
import SignUp from "./SignUp";
import LogIn from "./LogIn";
import ReturnLink from "./ReturnLink";

interface SuccessState {
  passwordAValue: string;
  passwordBValue: string;
  formMsg: string;
  isError: boolean;
  isLoading: boolean;
  isFinished: boolean;
  isShowingModal: boolean;
}

interface SignUpRequest {
  password: string;
  token: string;
}

interface LogInRequest {
  email: string;
  password: string;
}

interface SuccessProps extends RouterState {
  isLoggedIn: boolean;
  saveLoginToken: (token: string) => void;
}

class SuccessContainer extends React.Component<SuccessProps, SuccessState> {
  public state: SuccessState = {
    passwordAValue: "",
    passwordBValue: "",
    formMsg: "",
    isLoading: false,
    isFinished: this.props.isLoggedIn,
    isError: false,
    isShowingModal: false,
  };

  // TODO: get native translation
  private syncSignUpValidation = (): boolean => {
    let errorMsg;

    if (this.state.passwordAValue !== this.state.passwordBValue) {
      errorMsg = "Cả hai mật khẩu không giống nhau";
    } else if (
      !this.state.passwordAValue.length ||
      this.state.passwordAValue.length < 8
    ) {
      errorMsg = "Mật khẩu phải lớn hơn 7 chữ cái";
    }

    if (errorMsg) {
      this.setState(state => ({ ...state, isError: true, formMsg: errorMsg }));
      return false;
    }

    return true;
  };

  private syncLogInValidation = (): boolean => {
    let errorMsg;

    if (
      !this.state.passwordAValue.length ||
      this.state.passwordAValue.length < 8
    ) {
      errorMsg = "Mật khẩu phải lớn hơn 7 chữ cái";
    }

    if (errorMsg) {
      this.setState(state => ({ ...state, isError: true, formMsg: errorMsg }));
      return false;
    }

    return true;
  };

  private updatePasswordState = (key: string) => (
    event: React.SyntheticEvent<HTMLInputElement>,
  ) => {
    const input = event.target as HTMLInputElement;
    this.setState(state => ({ ...state, [key]: input.value }));
  };

  private structureSignUpRequest = (): SignUpRequest => ({
    password: this.state.passwordAValue,
    token: (this.props.location as Location).state.token,
  });

  private structureLogInRequest = (): LogInRequest => ({
    password: this.state.passwordAValue,
    email: (this.props.location as Location).state.email,
  });

  private handleSubmit = (
    endpoint: string,
    method: "post" | "put",
    request: SignUpRequest | LogInRequest,
    syncValidation: () => boolean,
  ) => async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (!syncValidation()) {
      return;
    }

    // Set loading state, clear any sync error/form message
    this.setState(state => ({
      ...state,
      isLoading: true,
      formMsg: "",
      isError: false,
    }));

    let newState: Partial<SuccessState>;
    try {
      // Perform request
      const { message, token }: any = await http[method](endpoint, request);

      this.props.saveLoginToken(token);

      newState = {
        formMsg: message,
        isFinished: true,
        isShowingModal: true,
      };
    } catch (error) {
      newState = {
        isError: true,
        formMsg: error.message,
      };
    } finally {
      this.setState(state => ({
        ...state,
        isLoading: false,
        ...newState,
      }));
    }
  };

  private handleModalClose = () =>
    this.setState(state => ({ ...state, isShowingModal: false }));

  public render() {
    const { location: loc } = this.props;

    // Send user to homepage if location state not set (from response from step 5 submit req)
    if (
      !loc ||
      !loc.state ||
      loc.state.new_customer == null ||
      loc.state.email == null
    ) {
      return <Redirect to="/" />;
    }

    return (
      <Success
        formComponent={this.renderForm()}
        handleModalClose={this.handleModalClose}
        {...this.state}
      />
    );
  }

  private renderForm() {
    const location = this.props.location as Location;

    if (this.state.isFinished) {
      return <ReturnLink />;
    }

    return location.state.new_customer ? (
      <SignUp
        {...this.state}
        handlePasswordAChange={this.updatePasswordState("passwordAValue")}
        handlePasswordBChange={this.updatePasswordState("passwordBValue")}
        handleSubmit={this.handleSubmit(
          "data/customers/password",
          "put",
          this.structureSignUpRequest(),
          this.syncSignUpValidation,
        )}
      />
    ) : (
      <LogIn
        {...this.state}
        email={location.state.email}
        passwordValue={this.state.passwordAValue}
        handlePasswordChange={this.updatePasswordState("passwordAValue")}
        handleSubmit={this.handleSubmit(
          "auth/customers/login",
          "post",
          this.structureLogInRequest(),
          this.syncLogInValidation,
        )}
      />
    );
  }
}

const mapStateToProps = (state: RootState): Partial<SuccessProps> => ({
  isLoggedIn: authSelectors.isLoggedIn(state),
});

const mapDispatchToProps = (dispatch: Dispatch): Partial<SuccessProps> => ({
  saveLoginToken: token => dispatch(authActions.saveToken(token)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SuccessContainer);



// WEBPACK FOOTER //
// ./src/routes/OrderSuccess/components/SuccessContainer.tsx